import { render } from "./MiniStat.vue?vue&type=template&id=0ac9ec1e"
import script from "./MiniStat.vue?vue&type=script&lang=js"
export * from "./MiniStat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__